<template>
  <div class="searchTag flex_c_start">
    <div class="flex_r margint20">
      <div class="subtitle f20 line28 fw600">类型</div>
      <div
        v-if="!showDiy"
        @click="setInx('type', '-1')"
        :class="[type == 0 && 'ftheme']"
        class="tag f16 line22 cursor marginl32"
      >
        不限
      </div>
      <div
        @click="setInx('type', k)"
        v-for="(v, k) in typeArr"
        :key="k"
        :class="[type == v.id && 'ftheme']"
        class="tag f16 line22 cursor marginl32"
      >
        {{ v.name }}
      </div>
    </div>

    <div class="flex_r margint20">
      <div class="subtitle f20 line28 fw600">主题</div>
      <div
        v-if="!showDiy"
        @click="setInx('topic', '-1')"
        :class="[topic == 0 && 'ftheme']"
        class="tag f16 line22 cursor marginl32"
      >
        不限
      </div>
      <div
        @click="setInx('topic', k)"
        v-for="(v, k) in topicArr"
        :key="k"
        :class="[topic == v.id && 'ftheme']"
        class="tag f16 line22 cursor marginl32"
      >
        {{ v.name }}
      </div>
    </div>

    <div class="flex_r margint20">
      <div class="subtitle f20 line28 fw600">职业</div>
      <div
        v-if="!showDiy"
        @click="setInx('job', '-1')"
        :class="[job == 0 && 'ftheme']"
        class="tag f16 line22 cursor marginl32"
      >
        不限
      </div>
      <div
        @click="setInx('job', k)"
        v-for="(v, k) in jobArr"
        :key="k"
        :class="[job == v.id && 'ftheme']"
        class="tag f16 line22 cursor marginl32"
      >
        {{ v.name }}
      </div>
    </div>

    <div class="flex_r margint20">
      <div class="subtitle f20 line28 fw600">性别</div>
      <div
        v-if="!showDiy"
        @click="setInx('sex', '-1')"
        :class="[sex == 0 && 'ftheme']"
        class="tag f16 line22 cursor marginl32"
      >
        不限
      </div>
      <div
        @click="setInx('sex', k)"
        v-for="(v, k) in sexArr"
        :key="k"
        :class="[sex == v.id && 'ftheme']"
        class="tag f16 line22 cursor marginl32"
      >
        {{ v.name }}
      </div>
    </div>
    <div v-if="showDiy" class="flex_r zdy margint20">
      <div class="subtitle f20 line28 fw600">标签</div>
      <div class="marginl32 flex_r">
        <div @click="add" class="flex_r_center flex0 add">
          <span>新增</span>
          <svgIcon class="fgray marginl4" name="add" />
        </div>
        <el-input
          @change="changeInput"
          v-for="(item, index) in input"
          :key="index"
          suffix-icon="el-icon-edit"
          v-model="input[index]"
          placeholder="请输入自定义标签"
        ></el-input>
      </div>
    </div>
    <div class="flex_r margint20">
      <div class="subtitle f20 line28 fw600">地区</div>
      <div class="tag f16 line22 marginl32">
        <el-select
          @change="change"
          :value="provinceName"
          placeholder="不限省份"
        >
          <el-option
            v-for="item in provinceArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="tag f16 line22 marginl32">
        <el-select
          @change="changeCity"
          :value="cityName"
          placeholder="不限城市"
        >
          <el-option
            v-for="item in cityArr"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "searchTag",
  props: ["type", "topic", "sex", "job", "showDiy", "cityId", "provinceId"],
  data() {
    return {
      typeArr: [],
      jobArr: [],
      sexArr: [],
      topicArr: [],
      province: 0,
      provinceName: "",
      provinceArr: [],
      city: 0,
      cityName: "",
      cityArr: [],
      input: [],
    };
  },
  watch: {
    provinceId(newv) {
      if (this.province != newv) {
        this.province = newv;
        this.city = this.cityId;
        this.getArea(this.province, "cityArr");
      }
    },
  },
  mounted() {
    this.getTagList();
    this.getArea(0, "provinceArr");
  },
  methods: {
    add() {
      if (this.input.length > 2) return this.$message.error("最多添加3个");
      this.input.push("");
    },
    change(v) {
      this.province = v;
      let arr = this.provinceArr;
      if (v > 0) {
        this.getArea(v, "cityArr");
      }else{
        this.city = 0;
        this.cityName = '不限';
        this.cityArr = [];
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == v) {
          this.provinceName = arr[i].name;
          break;
        }
      }
      this.changeZdy("province", this.province);
    },
    changeCity(v) {
      this.city = v;
      let arr = this.cityArr;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id == v) {
          this.cityName = arr[i].name;
          break;
        }
      }
      this.changeZdy("city", this.city);
    },
    async getTagList() {
      let data = await this.$http.get(this.$api.getTags);
      let { type, job, sex, topic } = data.data;
      this.typeArr = type;
      this.jobArr = job;
      this.sexArr = sex;
      this.topicArr = topic;
    },
    async getArea(id, type) {
      let data = await this.$http.get(this.$api.getAreas, {
        params: {
          no_group: 1,
          is_no: 1,
          id,
        },
      });
      this[type] = data.data;
      if (this.province) {
        // provinceName
        let arr = this.provinceArr;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == this.province) {
            this.provinceName = arr[i].name;
            break;
          }
        }
      }
      if (this.city) {
        // cityName
        let arr = this.cityArr;
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].id == this.city) {
            this.cityName = arr[i].name;
            break;
          }
        }
      }
    },
    changeInput() {
      this.changeZdy("tags", this.input);
    },
    changeZdy(type, data) {
      this.$emit("getArea", { key: type, val: data });
    },
    setInx(type, inx) {
      this.$emit("getList", { tagType: type, inx, input: this.input });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .zdy .el-input.el-input--suffix {
  margin-right: 10px;
}
/deep/ .el-input__inner {
  background: transparent;
  width: 180px;
}
/deep/ .el-button.el-button--default {
  background: transparent;
}
.subtitle {
  white-space: nowrap;
}
.searchTag {
  padding: 32px;
  background: #fafafa;
  .add {
    width: 80px;
    height: 40px;
    border-radius: 5px;
    margin-right: 10px;
    cursor: pointer;
    border: 1px solid #e6e6e6;
  }
}
</style>